export default {
  name: "Other Information",
  prefix: "F.d",
  sections: [
    {
      fields: [
        {
          code: "F.d.1",
          machine_name: "suggestedSocCode",
          widget: "soc",
          label: "Suggested SOC (O*NET/OEWS) code",
          field_to_modify: "suggestedSocTitle",
          validate: ["required"],
          tooltip: `Enter the suggested six or eight-digit Standard Occupational Classification (SOC)/Occupational Network (O*NET) code for the occupation, which most clearly describes the work to be performed. The suggested SOC may be used as a tool in the determination process; however, the SOC issued with the determination may differ.
          <ul><li>Enter the suggested occupational title associated with the SOC/O*NET code. The suggested occupational title may be used as a tool in the determination process; however, the SOC and occupational title issued with the determination may differ from the suggested SOC and occupational title.</li></ul>`,
        },
        {
          code: "F.d.1",
          machine_name: "suggestedSocTitle",
          widget: "text",
          label: "Suggested SOC (O*NET/OEWS) occupation title",
          // validate: ["required"],
          hidden: true,
        },
        {
          code: "F.d.2",
          machine_name: "supervisorJobTitle",
          label:
            "Job title of the official the employee will report to for this job opportunity (if applicable) §",
          tooltip: `Provide the job title of the official the employee will report to for this job opportunity, if applicable.`,
          widget: "text",
          maxLength: 200,
        },
        {
          isGroup: {
            code: "F.d.3",
            machine_name: "travelRequired",
            label:
              "Will travel be required in order to perform the job duties?",
            type: "radio",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: 1,
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: 0,
                validate: ["required"],
                clearSchema: ["travelDetails"],
              },
            ],
            tooltip: `If travel is required to perform the job duties, mark “Yes.” Otherwise, mark “No.”
            <ul><li>a. If “Yes” in question 3, provide details as to the area(s) of travel required, the frequency of the travel required, and the nature of the travel. Note: A prevailing wage cannot be provided for unanticipated worksites.</li></ul>`,
          },
        },
        {
          code: "F.d.3.a",
          machine_name: "travelDetails",
          label: `If “Yes,” provide geographic location and frequency of the travel. §`,
          widget: "text_area",
          width: 8,
          rows: 8,
          inputLimit: 2000,
          validate: [
            {
              isRequired: "travelRequired",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: 1,
              },
            },
          ],
          disabled: true,
          disableWhenField: {
            when: "travelRequired",
            is: 0,
          },
        },
      ],
    },
  ],
};
